import { render, staticRenderFns } from "./FormAction.vue?vue&type=template&id=6d384858"
import script from "./FormAction.vue?vue&type=script&lang=js"
export * from "./FormAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports